<template>
  <span
    :class="{
      'cursor-not-allowed': !enabled && !active
    }"
    :title="myTitle"
    class="ml-4 h-6 w-6 border border-roc-blue rounded bg-white flex justify-center items-center"
    @click="toggleWonderActive"
  >
    <i
      v-if="active"
      class="fas fa-check"
    />
  </span>
</template>

<script>
import {computed} from 'vue';

export default {
  props: {
    wonder: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      required: true
    },
    wonderCount: {
      type: Number,
      required: true
    }
  },
  emits: ['activate'],
  setup(props, context) {
    const enabled = computed(() => {
      return props.wonderCount < 4;
    });

    return {
      enabled,

      myTitle: computed(() => {
        if (enabled.value) {
          return props.active ? 'Deactivate' : 'Activate';
        }
        return 'Please deactivate one of your active wonders to activate this one.';
      }),

      toggleWonderActive() {
        if (enabled.value || props.active) {
          context.emit('activate', props.wonder.id);
        }
      }
    };
  }
};
</script>
